<form class="form-validation">

    <div class="modal-header bg-primary text-light">
        <h5 class="modal-title">Extended Data</h5>
    </div>
    <div class="modal-body">
        <div class="row center">
            <table class="table table-responsive">
                <thead>
                    <tr>
                        <th class="col-6">Field</th>
                        <th class="col-3">Area (m2)</th>
                        <th class="col-3">U Value (W/m<sup>2</sup>K)</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let detail of bdMainBuildingExtendedRoofDetails; let i = index">
                        <tr>
                            <td>
                                <span>Flat Ceiling 1</span>
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.flatCeilingOneArea" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.flatCeilingOneUValue" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Flat Ceiling 2</span>
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.flatCeilingTwoArea" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.flatCeilingTwoUValue" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Slope 1</span>
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.slopeOneArea" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.slopeOneUValue" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Slope 2</span>
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.slopeTwoArea" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.slopeTwoUValue" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Stud Wall 1</span>
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.studWallOneArea" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.studWallOneUValue" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Stud Wall 2</span>
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.studWallTwoArea" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.studWallTwoUValue" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Gable Wall 1</span>
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.gableWallOneArea" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.gableWallOneUValue" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Gable Wall 2</span>
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.gableWallTwoArea" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                            <td>
                                <input type="number" class="form-control" [(ngModel)]="detail.gableWallTwoUValue" [ngModelOptions]="{ standalone: true }" [disabled]="!isEdit" min="0" step="0.01" />
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-dark" (click)="onClose()">Close</button>
        </div>
    </div>
</form>